module.exports = [
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Système de vidage - remplissage",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche Twistfree 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche Twistfree 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexible de douche Twistfree 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flexible GROHE Silverflex avec raccord rotatif pour fonction TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Système de vidage - remplissage",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 Système de douche avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec inverseur",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douchette",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 400 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Ensemble de douchette à main (160 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul Cosmopolitan, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27742000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27742000/640/27742000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ensemble de douche 4 jets avec support mural",
		"textblock_1st_text": "27742000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27742000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Ensemble de douchette à main (160 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26170000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26170000/640/26170000.jpg",
		"headline": "Rainshower Veris 300 x 150",
		"subheadline": "Ensemble douche de tête et bras 422 mm, 1 jet",
		"textblock_1st_text": "26170000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26170000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26170LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26170LS0/640/26170LS0.jpg",
		"headline": "Rainshower Veris 300 x 150",
		"subheadline": "Ensemble douche de tête et bras 422 mm, 1 jet",
		"textblock_1st_text": "26170LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26170LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Ensemble de douche 4 jets avec support mural",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 210 avec mitigeur thermostatique et bec de bain",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ensemble de douche 1 jet avec barre",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul Cosmopolitan, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Douchette 4 jets",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul® Cosmopolitan 130, douchette, 4+ types de jet",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ensemble douche de tête et bras 422 mm, 1 jet",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171000/640/26171000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ensemble douche de tête et bras 422 mm, 1 jet",
		"textblock_1st_text": "26171000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26171000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Ensemble douche de tête et bras plafonnier 142 mm, 1 jet",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Ensemble douche de tête et bras 422 mm, 1 jet",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26259000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26259000/640/26259000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Ensemble douche de tête et bras 422 mm, 1 jet",
		"textblock_1st_text": "26259000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26259000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ensemble douche de tête et bras plafonnier 142 mm, 1 jet",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ensemble douche de tête et bras plafonnier 142 mm, 1 jet",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria XXL avec thermostatique ; chromé et de conception allemande, doté d\\'une douche de tête métallique de 310 mm et d\\'une douchette 110 mm à trois jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Douchette 1 jet",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ensemble de douche 1 jet avec barre",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Douchette latérale 1 jet",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27488000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27488000/640/27488000.jpg",
		"headline": "Rainshower",
		"subheadline": "Bras de douche 275 mm",
		"textblock_1st_text": "27488000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27488000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27271000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27271000/640/27271000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Douche de tête 1 jet",
		"textblock_1st_text": "27271000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27271000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Colonne de douche avec thermostatique <br />et douchettes latérales",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower 310 avec mitigeur thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Système de douche GROHE Euphoria Cube XXL 230 avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Corps encastré universel 1/2",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set de douche Rainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Set de douche Rainshower 310 SmartActive Cube avec thermostatique Grohtherm SmartControl, pour installation encastrée à trois sorties, douche de tête, douchette, bras de douche et flexible. Forme carrée. Finition chromée, fabriquée en Allemagne.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Set de douche Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Set de douche Rainshower 310 SmartActive avec thermostatique Grohtherm SmartControl, pour installation encastrée à trois sorties, douche de tête, douchette, bras de douche et flexible. Forme ronde. Finition chromée, fabriquée en Allemagne.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl bain/douche pour installation encastrée trois sorties. Forme ronde, Moon White, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl bain/douche pour installation encastrée trois sorties. Forme carrée, Moon White, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Support mural pour douchette",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ensemble douche de tête et bras 380 mm, 1 jet",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée deux sorties. Forme carrée, Moon White, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée une sortie. Forme carrée, Moon White, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée deux sorties. Forme ronde, Moon White, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée une sortie. Forme ronde, Moon White, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée une sortie. Forme ronde, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Système de douche exposé GROHE Rainshower SmartControl 360 MONO avec thermostatique. Chromée, écologique et fabriquée en Allemagne : Douche de tête de 360 mm (plaque de jet blanche) et douchette de 115 mm avec quatre jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "Système de douche exposé GROHE Rainshower SmartControl 360 DUO avec thermostatique. Douche de tête de 360 mm (plaque de jet blanche) chromée, écologique et fabriquée en Allemagne, avec jet GROHE TrioMassage et douchette de 115 mm avec deux jets.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Corps encastré pour douche de tête 1/2",
		"textblock_1st_text": "26264001",
		"textblock_2nd_text": "GROHE Rainshower® SmartControlboîtier d\\'encastrement pour ensemble de douche de tête GROHE Rainshower® 360 DUO (26254000)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Ensemble de douche 4 jets",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Ensemble de douchette à main (130 mm), barre de douche (600 mm) et flexible de douche (1750 mm) GROHE Power&Soul, 9,5m/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl bain/douche pour installation encastrée trois sorties. Forme carrée, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée deux sorties et support de douchette intégré. Forme carrée, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée deux sorties. Forme carrée, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 1 sortie",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée une sortie. Forme carrée, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 3 sorties",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl bain/douche pour installation encastrée trois sorties. Forme ronde, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée deux sorties et support de douchette intégré. Forme ronde, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Thermostatique pour installation encastrée 2 sorties",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Thermostatique Grohtherm SmartControl pour installation encastrée deux sorties. Forme ronde, finition chromée, fabriqué en Allemagne par GROHE. Écologique et fonctions de sécurité",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Corps encastré universel 1/2",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Mitigeur thermostatique douche 1/2\" avec ensemble de douche",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 2000 Perfect avec douche de tête Rainshower Cosmopolitan 210 mm métallique, douchette Euphoria Cosmopolitan et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 3000 Perfect, avec douche de tête métallique Rainshower Cosmopolitan 310 mm, douchette Sena et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Coude à encastrer 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Coude à encastrer Eurocube avec support mural, finition chromée et de conception allemande.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Système de douche GROHE Rainshower® SmartControl 360 DUO avec thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "26361000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barre de douche 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ensemble de douche 2 jets avec barre",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Ensemble de douchette à main (115 mm), barre de douche (900 mm) et flexible de douche (1750 mm) GROHE Power&Soul",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Ensemble de douche 2 jets avec barre",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Set de douche avec Tempesta 210",
		"textblock_1st_text": "25183001",
		"textblock_2nd_text": "Ensemble de douche GROHE Eurosmart Cosmopolitan Perfect avec mitigeur monocommande à encastrer, douche de tête de 210 mm et douchette chromée à deux jets de 100 mm.  Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "Set douche de tête et bras 142 mm GROHE Rainshower 310 SmartActive à 2 jets. Douche de tête 310 mm avec bras de douche plafonnier de 142 mm, finition chromée, forme ronde. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Set douche de tête et bras 430 mm, 2 jets",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "Set douche de tête et bras GROHE Rainshower 310 SmartActive 2 jets. douche de tête 310 mm avec bras de douche 400 mm, finition chromée et plaque de jets blanche, forme ronde. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Set de douche avec Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Set de douche GROHE Grohtherm 1000 avec douche de tête Tempesta de 210 mm et douchette de 100 mm à deux jets en finition chromée.  Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Ensemble douche de tête et bras plafonnier 142 mm, 3 jets",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "Set douche de tête et bras GROHE Euphoria 260 SmartControl avec trois zones de jets. Douche de tête 260 mm et bras de plafonnier GROHE Rainshower 142 mm en finition chromée. Facile à installer et à nettoyer. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Ensemble douche de tête et bras plafonnier 380 mm, 3 jets",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "Set douche de tête et bras GROHE Euphoria 260 SmartControl avec trois zones de jets. Douche de tête 260 mm et bras GROHE Rainshower 380 mm en finition chromée. Facile à installer et à nettoyer. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "Système de douche GROHE Euphoria 260 avec thermostatique, douche de tête de 260 mm 3 jets à économie d\\'eau et douchette de 110 mm à 3 jets, finition chromée. Facile à installer et à nettoyer. Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "Système bain/douche GROHE Euphoria 260 avec thermostatique bain/douche, douche de tête de 260 mm à 3 jets permettant d\\'économiser de l\\'eau et douchette de 110 mm à 3 jets, finition chromée. Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "Système de douche GROHE Euphoria 260 avec mitigeur monocommande, douche de tête de 260 mm à 3 jets permettant d\\'économiser de l\\'eau et douchette de 110 mm à 3 jets, finition chromée. Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "Système de douche GROHE Euphoria 260 avec inversion. douche de tête de 260 mm à 3 jets permettant d\\'économiser de l\\'eau et douchette de 110 mm à 3 jets, finition chromée. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "Système de douche GROHE Euphoria 260 avec thermostatique, douche de tête 3 jets de 260 mm et douchette 3 jets de 110 mm, finition chromée. Facile à installer et à nettoyer. Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec mitigeur <br />monocommande",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "Système de douche GROHE Tempesta Cosmopolitan 210 avec mitigeur monocommande, douche de tête 210 mm et douchette 100 mm à deux jets en finition chromée. Facile à installer et à nettoyer. Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec thermostatique Bain/Douche",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "Système de douche GROHE Tempesta Cosmopolitan 210 avec thermostatique bain/douche, douche de tête 210 mm et douchette 100 mm à deux jets en finition chromée. Facile à installer et à nettoyer. Ingénierie allemande",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Colonne de douche avec mitigeur thermostatique",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "Système de douche GROHE Tempesta Cosmopolitan 210 avec thermostatique, douche de tête 210 mm et douchette 100 mm à deux jets en finition chromée. Facile à installer et à nettoyer. Ingénierie allemande.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Douchette 4 jets, blanc",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Douchette 2 jets, surface de jets blanche",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Colonne de douche avec inverseur manuel",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "Set douche de tête et bras GROHE Rainshower 310 SmartActive CUBE 2 jets. Douche de tête 310 mm avec bras de douche plafonnier 142 mm, finition chromée et plaque de jets blanche, forme carrée. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "Set douche de tête et bras 142 mm GROHE Rainshower 310 SmartActive CUBE 2 jets. Douche de tête 310 mm avec bras de douche plafonnier de 142 mm, finition chromée, forme carrée. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Set douche de tête et bras 430 mm, 2 jets",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "Set douche de tête et bras GROHE Rainshower 310 SmartActive CUBE 2 jets. Douche de tête 310 mm avec bras de douche 400 mm, finition chromée et plaque de jets blanche, forme carrée. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Set douche de tête et bras 142 mm, 2 jets",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "Set douche de tête et bras GROHE Rainshower 310 SmartActive 2 jets. douche de tête 310 mm avec bras de douche plafonnier 142 mm, finition chromée et plaque de jets blanche, forme ronde. Conçu en Allemagne",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Rupteur atmosphérique pour Rapido SmartBox",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bec Bain déverseur",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ensemble douche de tête et bras plafonnier 142 mm, 1 jet",
		"textblock_1st_text": "26067000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Ensemble de douche avec Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm 2000 New Perfect, incluant un robinet thermostatique",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Ensemble de douche avec Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Ensemble de douche GROHE Grohtherm Cube Perfect avec douche de tête Rainshower Allure 230 mm, douchette Euphoria Cube et mitigeur thermostatique à encastrer Rapido T.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Ensemble de douche thermostatique",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Thermostat de douche GROHE Grohtherm 1000 Cosmopolitan M avec ensemble de douche GROHE Euphoria 110 Massage, barre de douche 600 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "Ensemble de douche confort GROHE Grohtherm 3000 Cosmopolitan, thermostat encastré inclus",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Ensemble de douche avec Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "Ensemble de douche confort GROHE Grohtherm 3000 Cosmopolitan, thermostat encastré inclus",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.fr/fr_fr/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.fr/fr_fr/a-votre-service/partenaires/geolocalisation-partenaires.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_fr_fr.json
// module id = 831
// module chunks = 0